import { useEffect, useState } from 'react';

export default function useDocumentVisibilityChange(callback) {
  const [visibilityState, setVisibilityState] = useState(
    document.visibilityState,
  );

  function handleVisibilityChange() {
    setVisibilityState(document.visibilityState);
    callback?.(document.visibilityState);
  }

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [callback]);

  return visibilityState;
}
